import { currencyFormat } from 'common/helpers/numberHelper';

const BottleDeposit = (props) => {
  const { cart, settings } = props;
  if (!cart.bottleDepositTotal || cart.bottleDepositTotal === 0) {
    return null;
  }
  return (
    <div>
      <div>Bottle Deposit</div>
      <div>{currencyFormat(cart.bottleDepositTotal, settings)}</div>
    </div>
  );
};

export default BottleDeposit;
